import React from 'react';
import { cx } from 'linaria';
import { mainPriceDefaultClass, padLeft, padRight } from '../product-special-price/styles';

type ProductPriceProps = {
  uom?: string;
  priceFirst?: string;
  priceSecond?: string | null;
  currency: string;

  mainPriceClassName?: string;
  fractPriceClassName?: string;
};

export const ProductPrice: React.FC<ProductPriceProps> = ({
  uom,
  priceFirst,
  priceSecond,
  currency,
  mainPriceClassName,
  fractPriceClassName,
}) => {
  const priceFirstWithComma = `${priceFirst},`;

  return (
    <div data-qa="product-primary-price">
      <span className={cx(mainPriceDefaultClass, mainPriceClassName)} data-qa="primary-price-main">
        {priceSecond ? priceFirstWithComma : priceFirst}
      </span>
      <span className={cx(fractPriceClassName, padLeft)} data-qa="primary-price-fract">
        {priceSecond}
      </span>
      <span className={cx(fractPriceClassName, padRight, padLeft)}>
        {`${currency}${uom ? `/${uom}` : ''}`}
      </span>
    </div>
  );
};
